import { Popover } from 'antd';
import { useState } from 'react';

import MoreIcon from './icon';
import styles from './style.module.scss';

export type MoreMenuProps = Array<{
  key: string;
  label: string | React.ReactNode;
  danger?: boolean;
  onClick?: () => void;
}>;

export type MenuProps = {
  menu: MoreMenuProps | null | undefined;
  icon?: React.ReactNode;
  onClose?: () => void;
};
export const PopoverContent: React.FC<MenuProps> = ({ menu, onClose }) => {
  if (!menu || !menu.length) {
    return;
  }
  return (
    <div className={styles['popover-menu']} onClick={(e) => e.stopPropagation()}>
      {menu.map((item) => {
        return (
          <div
            key={item.key}
            onClick={() => {
              item.onClick?.();
              onClose?.(); // 点击菜单项后关闭 Popover
            }}
            className={`${styles['popover-menu-item']} ${item.danger ? styles['popover-menu-item__danger'] : ''}`}
          >
            <div className={styles['popover-menu-item-title']}>{item.label}</div>
          </div>
        );
      })}
    </div>
  );
};

const MoreMenu: React.FC<MenuProps> = (props) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };
  if (!props.menu || !props.menu.length) {
    return null;
  }
  return (
    <Popover
      align={{
        offset: [6, 0],
      }}
      // destroyOnHidden
      classNames={{
        root: styles['more-operate-popover'],
      }}
      arrow={false}
      content={<PopoverContent menu={props.menu} onClose={() => setOpen(false)} />}
      placement="rightTop"
      open={open}
      onOpenChange={handleOpenChange}
    >
      <div
        className={`cursor-pointer group flex justify-end`}
        onClick={(e) => e.stopPropagation()}
      >
        {props.icon || <MoreIcon />}
      </div>
    </Popover>
  );
};

export default MoreMenu;
